import BaseItem, { Rarity } from './base_item';

export default class Chair extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "chair.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15;}
    static get height() { return 8;}

    static get mass() { return 1;}
    static get rarity() { return Rarity.COMMON; }
    static get electronic() { return false; }


    static get type() { return 'chair'}
    static get label() { return 'chair'}
    static get description() { return game.rnd.pick([
        `It's a chair! Too bad you have no sitting animation.`,
        `Chair, the alien menace.`,
        `Wherever you go, always take your chair with you.`
    ])}
}


// WEBPACK FOOTER //
// ./src/objects/items/chair.js